/*eslint no-undef: 0*/

import Swiper, {Navigation, Pagination} from 'swiper';
Swiper.use([Navigation, Pagination]);
import {getDeviceBreakpoints} from '../util/util';


//
const slider = () => {
  // eslint-disable-next-line no-unused-vars
  let swiper = null;
  const elements = document.querySelectorAll('.js-slider');

  if (elements.length === 0) return;

  [].forEach.call(elements, element => {

    swiper = new Swiper(element, {
      loop: true,
      speed: 500,
      // Navigation arrows
      navigation: {
        nextEl: element.parentNode.querySelector('.js-swiper-button-next'),
        prevEl: element.parentNode.querySelector('.js-swiper-button-prev'),
      },
      pagination: {
        el: element.parentNode.querySelector('.swiper-pagination'),
        clickable: true,
      },
      slidesPerView: 1,
      spaceBetween: 30,
    });
  })
};


// Build slider on mobile/smaller screens
let mblSwiper = 'undefined';

const mobileSlider = () => {
  const elements = $(document.querySelectorAll('.js-mobile-slider'));

  if (elements.length === 0) return;

  if (window.innerWidth <= getDeviceBreakpoints().iPadBreakpoint && mblSwiper === 'undefined') {
    elements.each(function () {
      mblSwiper = new Swiper(this, {
        loop: true,
        speed: 700,
        pagination: {
          el: this.closest('.swiper-container-wrap').querySelector('.swiper-pagination'),
          clickable: true,
        },
        slidesPerView: 1,
        spaceBetween: 30,
        breakpoints: {
          576: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
      });
    });
  } else if (window.innerWidth > getDeviceBreakpoints().iPadBreakpoint && mblSwiper !== 'undefined') {
    elements.each(function () {
      mblSwiper = this.swiper;
      // Reset slider by destroying the current instance

      this.swiper.slides.removeClass('swiper-slide-duplicate-active swiper-slide-duplicate-next swiper-slide-duplicate-prev swiper-slide-prev swiper-slide-active swiper-slide-next').removeAttr('style');

      mblSwiper.destroy();
      mblSwiper = 'undefined';
    });
  }
};


// Four slides carousel
const fourItemsCarousel = () => {
  // eslint-disable-next-line no-unused-vars
  let swiper = null;
  const elements = document.querySelectorAll('.js-four-items-carousel');

  if (elements.length === 0) return;

  [].forEach.call(elements, element => {

    swiper = new Swiper(element, {
      loop: true,
      speed: 500,
      // Navigation arrows
      navigation: {
        nextEl: element.parentNode.querySelector('.js-swiper-button-next'),
        prevEl: element.parentNode.querySelector('.js-swiper-button-prev'),
      },
      slidesPerView: 1,
      spaceBetween: 20,
      observeParents: true,
      observer: true,
      breakpoints: {
        576: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 30,
        },
      },
    });
  })
};


// Logos carousel
const logosCarousel = () => {
  // eslint-disable-next-line no-unused-vars
  let swiper = null;
  const elements = document.querySelectorAll('.js-logos-carousel');

  if (elements.length === 0) return;

  [].forEach.call(elements, element => {

    swiper = new Swiper(element, {
      loop: true,
      speed: 500,
      // Navigation arrows
      navigation: {
        nextEl: element.parentNode.querySelector('.js-swiper-button-next'),
        prevEl: element.parentNode.querySelector('.js-swiper-button-prev'),
      },
      slidesPerView: 2,
      spaceBetween: 20,
      observeParents: true,
      observer: true,
      breakpoints: {
        576: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 40,
        },
      },
    });
  })
};


export {
  fourItemsCarousel,
  logosCarousel,
  mobileSlider,
  slider,
};



// WEBPACK FOOTER //
// ./scripts/modules/slider.js